export enum ControlRxSubmissionType {
    New = 1,
    Revise = 2,
    Void = 3
}
